﻿﻿/**
 *  Примеры.
 *
 *  1. Минимальное встраивание:
 *
 *  <link rel="stylesheet" type="text/css" href="/assets/wm.user.block-1.8.1/css/user.block.css" />
 *  <script type="text/javascript" src="/assets/wm.user.block-1.8.1/js/user.block.autoload.js"  data-wmid="123456789012" data-uriservice-rid="00000000-0000-0000-0000-000000000000"></script>
 *
 *  2. Использование вместе с преварительно сформированным блоком:
 *
 *  <link rel="stylesheet" type="text/css" href="/assets/wm.user.block-1.8.1/css/user.block.css" />
 *
 *  <td class="header-user-block" data-role="header-user-block" data-wmid="123456789012" data-uriservice-rid="00000000-0000-0000-0000-000000000000">
 *      <div class="clearfix">
 *          <a target="_blank" href="https://login.wmtransfer.com/GateKeeper.aspx?RID=D0B27254-F6C0-4946-80BC-A3A400E3FE92&amp;Quiet=1&amp;WmId=123456789012" class="user-link-to-events">
 *              <img id="avatar" src="https://events.webmoney.ru/open/avatar.aspx?t=Url&amp;s=Tiny&amp;w=123456789012" alt="123456789012" title="123456789012" />
 *              <span id="wmid">WMID - 123456789012</span>
 *              <span id="nickname" class="user-nickname">WMID: 123456789012</span>
 *          </a>
 *
 *          <a class="icon-log-off" href="/Auth/SignOff" id="log-off"></a>
 *      </div>
 *
 *      <div class="login_popup_cont">
 *          <div class="user_top_info">
 *              <a href="https://login.wmtransfer.com/GateKeeper.aspx?RID=D0B27254-F6C0-4946-80BC-A3A400E3FE92&amp;Quiet=1&amp;WmId=123456789012" class="uti_img">
 *                  <img id="avatar" src="https://events.webmoney.ru/open/avatar.aspx?t=Url&amp;s=Small&amp;w=123456789012" alt="123456789012" title="123456789012" />
 *              </a>
 *              <div class="uti_descr">
 *                  <a href="https://login.wmtransfer.com/GateKeeper.aspx?RID=D0B27254-F6C0-4946-80BC-A3A400E3FE92&amp;Quiet=1&amp;WmId=123456789012" class="user_nickname user-nickname"><span>WMID: 123456789012</span></a>
 *                  <a href="https://login.wmtransfer.com/GateKeeper.aspx?RID=47C540AE-DAFB-420C-861F-A3A400E3D326&amp;Quiet=1&amp;WmId=123456789012" class="user_purse"><span>123456789012</span></a>
 *                  <a href="/Auth/SignIn" class="user_logout">
 *                      Выход
 *                  </a>
 *              </div>
 *          </div>
 *          <ul class="wmid_dop">
 *
 *          </ul>
 *          <a href="/Auth/SignOff" class="add_wmid">Добавить WMID</a>
 *          <a href="https://login.wmtransfer.com/GateKeeper/Options.aspx" class="login_settings">Настройки входа</a>
 *      </div>
 *  </td>
 *
 *  <script type="text/javascript" src="/assets/wm.user.block-1.8.1/js/user.block.autoload.js"></script>
 */
(function($) {
    "use strict";
// ReSharper disable DeclarationHides
function renderUserBlock($,it
/**/) {
"use strict";
/* globals _encodeHTML: false */
/* exported renderUserBlock */


var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (function (doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	}());var out=''; var lang = it.lang || $('html').attr('lang') || ''; if(lang.length > 2) { lang = lang.substr(0, 2); } lang = lang.toLowerCase(); var defaultSr = { User_Change: { ''  : 'Log in another WMID', 'es': 'Entrar en otro WMID', 'pt': 'Log em outro WMID', 'ru': 'Войти другим WMID', 'tr': 'Başka bir WMID ile giriş yapın', 'vi': 'Đăng nhập với WMID khác' }, User_Settings: { ''  : 'Login settings', 'es': 'Configuraciones de Sesión', 'pt': 'Configurações de sessão', 'ru': 'Настройки входа', 'tr': 'Giriş ayarları', 'vi': 'Thiết lập đăng nhập' }, User_SignOff: { ''  : 'Log out', 'es': 'Cerrar sesión', 'pt': 'Desligar', 'ru': 'Выход', 'tr': 'Çıkış', 'vi': 'Đăng xuất' }, Back: { ''  : 'Back', 'es': 'Atrás', 'pt': 'Voltar', 'ru': 'Назад', 'tr': 'Geri', 'vi': 'Trở lại' } }; var srParam = it.sr || {}; var sr = { User_Change: srParam.User_Change || defaultSr.User_Change[lang] || defaultSr.User_Change[''], User_Settings: srParam.User_Settings || defaultSr.User_Settings[lang] || defaultSr.User_Settings[''], User_SignOff: srParam.User_SignOff || defaultSr.User_SignOff[lang] || defaultSr.User_SignOff[''], Back: srParam.Back || defaultSr.Back[lang] || defaultSr.Back[''] }; var rememberStateUnknown = it.rememberStateUnknown === true; var uriServiceParam = it.uriService || {}; var uriService = { login: uriServiceParam.login || 'https://login.wmtransfer.com/', userKeeper: uriServiceParam.userKeeper, userProfile: uriServiceParam.userProfile, loginSettings: uriServiceParam.loginSettings, userSignoff: uriServiceParam.userSignoff, userChange: uriServiceParam.userChange, userChangeNew: uriServiceParam.userChangeNew, rid: uriServiceParam.rid, returnUrl: uriServiceParam.returnUrl || window.location }; if (!(uriService.userSignoff && uriService.userChange || uriService.rid)) { throw new Error('Required parameter it.uriService is missing or contains an invalid value.'); } if (uriService.login.lastIndexOf('/') !== uriService.login.length - 1) { uriService.login = uriService.login + '/'; } if(!uriService.userKeeper) { uriService.userKeeper = uriService.login + 'GateKeeper.aspx' + '?RID=__rid__' + '&Quiet=__quiet__' + '&WmId=__wmId__'; } if(!uriService.userProfile) { uriService.userProfile = uriService.login + 'GateKeeper.aspx' + '?RID=__rid__' + '&Quiet=__quiet__' + '&WmId=__wmId__'; } if(!uriService.loginSettings) { uriService.loginSettings = uriService.login + 'GateKeeper/Options.aspx'; } if(!uriService.userSignoff && uriService.rid) { uriService.userSignoff = uriService.login + 'GateKeeper/LogOff.aspx' + '?RID=__rid__' + '&WmId=__wmId__' + '&ReturnUrl=__returnUrl__'; } if(!uriService.userChangeNew) { if($.isFunction(uriService.userChange)) {  } else { if(uriService.userChange) { var queryParamPattern = /(\?|\&)WmId=__wmId__(\&|$)/i; if(rememberStateUnknown && queryParamPattern.test(uriService.userChange)) { uriService.userChangeNew = uriService.userChange.replace(queryParamPattern, '$1'); } else { uriService.userChangeNew = uriService.userChange; } } else { uriService.userChangeNew = uriService.login + 'GateKeeper.aspx' + '?RID=__rid__' + (!rememberStateUnknown ? '&WmId=__wmId__' : '') + '&Quiet=0' + '&ReturnUrl=__returnUrl__'; } } } if(!uriService.userChange) { uriService.userChange = uriService.login + 'GateKeeper.aspx' + '?RID=__rid__' + '&WmId=__wmId__' + '&Quiet=__quiet__' + '&ReturnUrl=__returnUrl__'; } function getKeeperHref(user) { if($.isFunction(uriService.userKeeper)) { return uriService.userKeeper.call(uriService, user); } if(uriService.userKeeper) {  var rids = { '': { ''  : 'D0B27254-F6C0-4946-80BC-A3A400E3FE92',  'ru': '47C540AE-DAFB-420C-861F-A3A400E3D326'   }, 1: { ''  : 'FDC51D96-C961-4967-A4CE-A3930133F11F',  'ru': '535E0FD1-2DB2-4906-B421-A3930133E774'   } }; rids['1'] = rids[1]; var keeperType = user.keeperType !== undefined ? user.keeperType : ''; var keeperRids = rids[keeperType] || rids['']; var rid = keeperRids[lang] || keeperRids['']; return uriService.userKeeper .replace('__rid__', encodeURIComponent(rid)) .replace('__wmId__', encodeURIComponent(user.wmId)) .replace('__quiet__', '1') .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl)); } throw new Error('User purse URI is not set up with the URI services.'); } function getEventsHref(user) { if($.isFunction(uriService.userProfile)) { return uriService.userProfile.call(uriService, user); }  if(uriService.userProfile) { return uriService.userProfile .replace('__rid__', '48CEEC81-2DF4-4B3A-B0BA-A0CB0106D464') .replace('__wmId__', encodeURIComponent(user.wmId)) .replace('__quiet__', '1') .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl)); } throw new Error('User profile URI is not set up with the URI services.'); } function getAvatarHref(user, size) { if (user.avatarUrl) { if(size === 'tiny') { return user.avatarUrl; } var pathEndPattern = /tiny((\.)(\w+))?$/i; if(pathEndPattern.test(user.avatarUrl)) { return user.avatarUrl.replace(pathEndPattern, (size + '$2$3')); } var queryParamPattern = /(\?|\&)s=tiny(\&|$)/i; if(queryParamPattern.test(user.avatarUrl)) { return user.avatarUrl.replace(queryParamPattern, ('$1s=' + size + '$2')); } return user.avatarUrl; } else { return 'https://events.webmoney.ru/open/avatar.aspx?w=' + encodeURIComponent(user.wmId) + '&t=Url&s=' + size + '&a=1'; } } function getLoginSettingsHref(user) { if($.isFunction(uriService.loginSettings)) { return uriService.loginSettings.call(uriService, user); } if(uriService.loginSettings) { return uriService.loginSettings .replace('__wmId__', encodeURIComponent(user.wmId)) .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl)); } throw new Error('Login settings URI is not set up with the URI services.'); } function getUserSignoffHref(user) { if($.isFunction(uriService.userSignoff)) { return uriService.userSignoff.call(uriService, user); } if(uriService.userSignoff) { return uriService.userSignoff .replace('__rid__', encodeURIComponent(uriService.rid)) .replace('__wmId__', encodeURIComponent(user.wmId)) .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl)); } throw new Error('User sign off URI is not set up with the URI services.'); } function getUserChangeHref(user) { if($.isFunction(uriService.userChange)) { return uriService.userChange.call(uriService, user); } if(user && uriService.userChange) { return uriService.userChange .replace('__rid__', encodeURIComponent(uriService.rid)) .replace('__wmId__', encodeURIComponent(user.wmId)) .replace('__quiet__', '1') .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl)); } else if(uriService.userChangeNew) { return uriService.userChangeNew .replace('__rid__', encodeURIComponent(uriService.rid)) .replace('__wmId__', '') .replace('__quiet__', '0') .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl)); } throw new Error('User change URI is not set up with the URI services.'); } var currentWmId = it.currentWmId; var data = it.data; if(!data) { throw new Error('Required parameter it.data is missing.'); } var users = data.users; var currentUser; for (var j in users) { if (users.hasOwnProperty(j)) { var u = users[j]; if (u.wmId === currentWmId) { currentUser = u; } } } if(!currentUser) { currentUser = { }; } if(!currentUser.wmId) { currentUser.wmId = currentWmId; } if(!currentUser.displayName) { currentUser.displayName = currentWmId; }out+='<div class="clearfix"> <a target="_blank" href="'+encodeHTML( getEventsHref(currentUser) )+'" class="user-link-to-events"> <img id="avatar" src="'+encodeHTML( getAvatarHref(currentUser, 'tiny') )+'" alt="';if(!currentUser.displayName || currentUser.displayName === currentUser.wmId){out+='WMID: ';}out+=''+encodeHTML( currentUser.displayName || currentUser.wmId )+'" title="';if(!currentUser.displayName || currentUser.displayName === currentUser.wmId){out+='WMID: ';}out+=''+encodeHTML( currentUser.displayName || currentUser.wmId )+'" /> <span id="nickname">WMID: '+encodeHTML( currentUser.wmId )+'</span> </a> <a class="icon-log-off" href="'+encodeHTML( getUserSignoffHref(currentUser) )+'" id="log-off"> </a></div><div class="login_popup_cont"> <div class="user_top_info"> <a target="_blank" href="'+encodeHTML( getEventsHref(currentUser) )+'" class="uti_img"> <img src="'+encodeHTML( getAvatarHref(currentUser, 'small') )+'" alt="';if(!currentUser.displayName || currentUser.displayName === currentUser.wmId){out+='WMID: ';}out+=''+encodeHTML( currentUser.displayName || currentUser.wmId )+'" title="';if(!currentUser.displayName || currentUser.displayName === currentUser.wmId){out+='WMID: ';}out+=''+encodeHTML( currentUser.displayName || currentUser.wmId )+'" /> </a> <div class="uti_descr"> <a target="_blank" href="'+encodeHTML( getEventsHref(currentUser) )+'" class="user_nickname"> <span>';if(!currentUser.displayName || currentUser.displayName === currentUser.wmId){out+='WMID: ';}out+=''+encodeHTML( currentUser.displayName || currentUser.wmId )+'</span> </a> <a target="_blank" href="'+encodeHTML( getKeeperHref(currentUser) )+'" class="user_purse"> <span>'+encodeHTML( currentUser.wmId )+'</span> </a> <a href="'+encodeHTML( getUserSignoffHref(currentUser) )+'" class="user_logout"> '+encodeHTML( sr.User_SignOff )+' </a> </div> </div> <ul class="wmid_dop"> ';var arr1=data.users;if(arr1){var user,i1=-1,l1=arr1.length-1;while(i1<l1){user=arr1[i1+=1];out+=' ';if(user.wmId !== currentUser.wmId){out+=' <li> <a href="'+encodeHTML( getUserChangeHref(user) )+'"> <img src="'+encodeHTML( getAvatarHref(user, 'tiny') )+'" /> <div class="u_info"> <div class="u_nickname">';if(!user.displayName || user.displayName === user.wmId){out+='WMID: ';}out+=''+encodeHTML( user.displayName || user.wmId )+'</div> <div class="u_wmid">'+encodeHTML( user.wmId )+'</div> </div> </a> </li> ';}out+=' ';} } out+=' </ul> <a href="'+encodeHTML( getUserChangeHref(null) )+'" class="add_wmid"> '+encodeHTML( sr.User_Change )+' </a> <a target="_blank" href="'+encodeHTML( getLoginSettingsHref(currentUser) )+'" class="login_settings"> '+encodeHTML( sr.User_Settings )+' </a> <a href="" class="login_close"> '+encodeHTML( sr.Back )+' </a></div>';return out;
}

/**
 *  @function loadUserBlock
 *  @summary Загружает данные для отрисовки блока залогиненного пользователя или выполнения автоматического входа
 *  незалогиненного пользователя.
 *
 *  @param {Object} [options={}]
 *  Объект настроек.
 *
 *  @param {boolean} [options.log=false]
 *  Если true, то работа функции логируется в консоль (через console.log).
 *
 *  @param {string} [options.wmId]
 *  WMID текущего залогиненного пользователя.
 *
 *  @param {string} [options.lang]
 *  Текущий язык. Если не указан, определяется по атрибуту lang корневого элемента html.
 *
 *  @param {boolean} [options.signOn=false]
 *  Если true, то вместо отрисовки блока пользователя выполняется автоматический вход.
 *  @param {boolean} [options.signOnAlways=false]
 *  Если true, то автоматический вход выполняется вне зависимости от предыдущих действий пользователя на вкладке. Если
 *  false или не указан, то автоматический вход выполняется только, если на данной вкладке ранее не выполнялся
 *  автоматический вход и пользователь не был залогинен.
 *
 *  @param {Object} [options.placeholder]
 *  Обёртка jQuery над элементом, содержимое которого заменяется на разметку блока пользователя. Если не указан, ищется
 *  автоматически в порядке приоритета:
 *  1. элемент с атрибутом data-role="header-user-block";
 *  2. элемент с атрибутом id="header-user-block";
 *  2. элемент с атрибутом class="header-user-block".
 *
 *  @param {boolean} [options.preRender]
 *  Если true, то производится преварительная отрисовка блока. Если false, то преварительная отрисовка блока не
 *  производится. Если не указан или undefined, то предварительная отрисовка блока производится в зависимости от
 *  изначальной разметки в элементе-маркере (options.placeholder). Предварительная отрисовка позволяет избежать видимых
 *  изменений шапки в случае, если разметка в элементе-маркере не соответствует разметке, отрисовываемой скриптом.
 *
 *  @param {Object} [options.uriService={}]
 *  Объект, предоставляющий URI WebMoney Login, авторизационных действий приложения и используемых в блоке пользователя
 *  ссылок.
 *  @param {string} [options.uriService.loginSso=uriService.login + 'GateKeeper/SingleSignOn.js']
 *  URI сервиса единого входа WebMoney Login.
 *  @param {string} [options.uriService.login='https://login.wmtransfer.com/']
 *  Базовый URI WebMoney Login.
 *  @param {string} [options.uriService.returnUrl=window.location]
 *  URI возврата после входа, смены пользователя и выхода.
 *  @param {string} [options.uriService.rid]
 *  RID, используемый подставляемый в шаблоны URI.
 *  @param {uriServiceUserCallback|string} [it.uriService.userKeeper]
 *  Шаблон URI страницы управления финансами пользователя, либо функция, возвращающая URI страницы управления финансами.
 *  По умолчанию формируется ссылка на вход через WebMoney Login. В качестве RID в шаблон подставляется RID страницы
 *  Кипера пользователя в зависимости от типа Кипера и языка.
 *  @param {uriServiceUserCallback|string} [it.uriService.userProfile]
 *  Шаблон URI профиля пользователя, либо функция, возвращающая URI профиля. По умолчанию формируется ссылка на вход
 *  через WebMoney Login. В качестве RID в шаблон подставляется RID WebMoney.Events.
 *  @param {uriServiceUserCallback|string} [it.uriService.loginSettings]
 *  Шаблон URI страницы настроек входа, либо функция, возвращающая URI страницы настроек. По умолчанию формируется
 *  ссылка на настройки Login.
 *  @param {uriServiceUserCallback|string} [options.uriService.userSignoff]
 *  Шаблон URI страницы выхода, либо функция, возвращающая URI страницы выхода. По умолчанию формируется ссылка на выход
 *  через WebMoney Login с указанным RID.
 *  @param {uriServiceUserCallback|string} [options.uriService.userChange]
 *  При отрисовке блока пользователя: шаблон URI страницы смены пользователя, либо функция, возвращающая URI страницы
 *  смены пользователя (запомненного ранее либо нового; для получения URI выбора нового незапомненного пользователя
 *  функция вызывается с пустым аргументом user).
 *  При автоматическом входе: шаблон URI страницы входа, либо функция, возвращающая URI страницы входа.
 *  По умолчанию формируется ссылка на вход через WebMoney Login с указанным RID.
 *  @param {uriServiceUserCallback|string} [options.uriService.userChangeNew]
 *  Шаблон URI страницы переключения на нового, ранее незапомненного пользователя. По умолчанию используется значение
 *  options.uriService.userChange.
 *
 *  @param {Object} [options.sr={}]
 *  Объект, содержащий локализованные строки для отрисовки блока пользователя. Если не указан, то используется
 *  локализация по умолчанию в зависимости от текущего языка.
 *  @param {string} [options.sr.User_Change]
 *  Локализация строки "Войти другим WMID".
 *  @param {string} [options.sr.User_Settings]
 *  Локализация строки "Настройки входа".
 *  @param {string} [options.sr.User_SignOff]
 *  Локализация строки "Выход".
 *  @param {string} [options.sr.Back]
 *  Локализация строки "Назад" (используется в мобильной версии).
 *
 *  @param {Object} [options.hooks={}]
 *  Объект, содержащий хуки. Позволяет указать свои функции, позволяющие использовать и изменять данные во время
 *  загрузки данных, отрисовки блока пользователя или выполения автоматического входа.
 *  @param {beforeGetUserDataCallback} [options.hooks.beforeGetUserData]
 *  Функция, вызываемая перед обращением к сервису WebMoney Login. Позволяет принудительно разрешить или запретить
 *  обращение к сервису Login и изменить URL сервиса.
 *  @param {afterGetUserDataCallback} [options.hooks.afterGetUserData]
 *  Функция, после получения данных от сервиса WebMoney Login. Позволяет изменить данные, полученные от сервиса.
 *  @param {beforeSignOnCallback} [options.hooks.beforeSignOn]
 *  Функция, вызываемая перед выполнением автоматического входа. Позволяет принудительно разрешить или запретить
 *  выполнение автоматического входа и изменить данные пользователя.
 *  @param {afterSignOnCallback} [options.hooks.afterSignOn]
 *  Функция, вызываемая после выполнения автоматического входа. Позволяет узнать данные пользователя и URL, на который
 *  произошло перенаправление для автоматического входа.
 *  @param {beforeRenderCallback} [options.hooks.beforeRender]
 *  Функция, вызываемая перед созданием разметки блока пользователя. Позволяет изменить данные о пользователе.
 *  @param {afterRenderCallback} [options.hooks.afterRender]
 *  Функция, вызываемая после созданием разметки блока пользователя. Позволяет изменить данные о пользователе, разметку
 *  и элемент, в который будет отрисована разметка.
 *
 *  @param {handleDataCallback} [options.handleData]
 *  Функция обработки данных, полученных от сервиса WebMoney Login. Переопределение этой функции позволяет заменить
 *  логику отрисовки блока пользователя и автомтического входа.
 *
 *  @param {boolean} [options.isCorsFullSupported=undefined]
 *  Если задано, задаёт поддержку CORS браузером. Если браузер не поддерживает CORS, то запрос на WebMoney Login не
 *  имеет смысла и не производится. Если параметр не задан (не true и не false), то поддержка CORS браузером
 *  определяется автоматически.
 */
function loadUserBlock(options) {
    "use strict";
    /* globals renderUserBlock: false */
    /* globals console: false */
    /* exported loadUserBlock */

    var $ = window.jQuery;

    if(!options) {
        options = {};
    }

    var log;
    if(options.log && console.log) {
        log = function() {
            var args = [];
            for(var i in arguments) {
                var a = arguments[i];
                if(typeof a === 'string') {
                    args.push(a);
                } else {
                    args.push(JSON.stringify(a));
                }
            }
            var argsString = args.join("");
            console.log(argsString);
        };
    } else {
        log = function() {};
    }

    var uriService = options.uriService || {};
    var uri;
    if (uriService.loginSso) {
        uri = uriService.loginSso;
    } else {
        if (!uriService.login) {
            uriService.login = 'https://login.wmtransfer.com/';
        }
        if (uriService.login.lastIndexOf('/') !== uriService.login.length - 1) {
            uriService.login = uriService.login + '/';
        }

        uri = uriService.login + 'GateKeeper/SingleSignOn.js';
    }
    var location = uriService.location || window.location;

    var hooks = options.hooks || {};

    function isCorsFullSupported() {
        if(options.isCorsFullSupported === true) {
            log('CORS check: CORS is enabled in input parameters.');
            return true;
        } else if (options.isCorsFullSupported === false) {
            log('CORS check: CORS is disabled in input parameters.');
            return false;
        } else if ('XMLHttpRequest' in window && 'withCredentials' in new XMLHttpRequest()) {
            var ua = window.navigator.userAgent;
            var fullCors = ua.indexOf('MSIE ') < 0 && ua.indexOf('Trident/') < 0;
            log('CORS check: Basic CORS support is present. User agent: ', ua, '. Full CORS support: ', fullCors, '.');
            return fullCors;
        } else {
            log('CORS check: CORS is not supported.');
            return false;
        }
    }

    function isSameDomain(currentLocation, destinationUri) {
        function getDomain(location) {
            var hostname = location.hostname;
            var idx = hostname.search(/(\w+(\.\w+))$/g);
            var domain = idx >= 0 ? hostname.substr(idx) : hostname;
            return domain;
        }

        var uriParser = document.createElement('a');
        uriParser.href = destinationUri;

        var currentDomain = getDomain(currentLocation);
        var destinationDomain = getDomain(uriParser);
        var result = destinationDomain && currentDomain && destinationDomain === currentDomain;

        log(
            'CORS check: destination domain: ', destinationDomain,
            '. Current domain: ', currentDomain,
            '. Is same domain: ', result, '.');
        return result;
    }

    var SingleSignOn = (function() {
        var singleSignOn = {};
        singleSignOn.sessionSetCalled = function(called) {
            var sessionStorage = window.sessionStorage;
            if (sessionStorage) {
                sessionStorage.setItem("SingleSignOnCalled", called ? "true" : "false");
                log('Session data: set SingleSignOnCalled to ', called, '.');
            }
        };
        singleSignOn.sessionGetCalled = function() {
            var sessionStorage = window.sessionStorage;
            if (sessionStorage) {
                var result = sessionStorage.getItem("SingleSignOnCalled") === "true";
                log('Session data: SingleSignOnCalled is ', result, '.');
                return result;
            }
            return false;
        };
        singleSignOn.handleData = function(data) {
            function getUserChangeHref(user) {
                if($.isFunction(uriService.userChange)) {
                    return uriService.userChange.call(uriService, user);
                }

                if(user && uriService.userChange) {
                    return encodeURI(uriService.userChange)
                        .replace('__rid__', encodeURIComponent(uriService.rid))
                        .replace('__wmId__', encodeURIComponent(user.wmId))
                        .replace('__quiet__', '1')
                        .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl));
                } else if(uriService.userChangeNew) {
                    return encodeURI(uriService.userChangeNew)
                        .replace('__rid__', encodeURIComponent(uriService.rid))
                        .replace('__wmId__', '')
                        .replace('__quiet__', '0')
                        .replace('__returnUrl__', encodeURIComponent(uriService.returnUrl));
                }

                throw new Error('User change URI is not set up with the URI services.');
            }

            var allowSignOn = data && data.loggedOn && data.wmId && (options.signOnAlways || !singleSignOn.sessionGetCalled());
            if(hooks.beforeSignOn) {
                var beforeSignOnArgs = {
                    "data": data,
                    "allowSignOn": allowSignOn
                };
                hooks.beforeSignOn(beforeSignOnArgs);
                data = beforeSignOnArgs.data;
                allowSignOn = beforeSignOnArgs.allowSignOn;
            }

            if(allowSignOn) {
                singleSignOn.sessionSetCalled(true);

                if(!uriService.userChange) {
                    uriService.userChange = uriService.login + 'GateKeeper.aspx' +
                                            '?RID=__rid__' +
                                            '&WmId=__wmId__' +
                                            '&Quiet=__quiet__' +
                                            '&ReturnUrl=__returnUrl__';
                }
                var user = {
                    wmId: data.wmId
                };
                var logOnUri = getUserChangeHref(user);

                var doRedirect = options.redirect || function(uri) {
                    if(uri) {
                        window.location = uri;
                    }
                };
                log('Single Sign On callback: redirecting to ', logOnUri, '.');
                doRedirect(logOnUri);

                if(hooks.afterSignOn) {
                    var afterSignOnArgs = {
                        "data": data,
                        "logOnUri": logOnUri
                    };
                    hooks.afterSignOn(afterSignOnArgs);
                }
            } else {
                log('Single Sign On callback: automatic sign on is unavailable or disabled for current session.');
            }
        };

        return singleSignOn;
    })();

    var UserBlockRenderer = (function() {
        var instance = {};

        function detectPlaceholder(options) {
            var placeholder = options.placeholder;

            if(!placeholder) {
                var byDataRole = $('[data-role="header-user-block"]');
                if(byDataRole.length > 0) {
                    placeholder = byDataRole;
                }
            }

            if(!placeholder) {
                var byId = $("#header-user-block");
                if(byId.length > 0) {
                    placeholder = byId;
                }
            }

            if(!placeholder) {
                placeholder = $(".header-user-block");
            }

            return placeholder;
        }

        function doRender(data, rememberStateUnknown) {
            var wmId = options.wmId || data.wmId;

            var renderParams = {
                "currentWmId": wmId,
                "data": data,
                "sr": options.sr,
                "lang": options.lang,
                "uriService": uriService,
                "rememberStateUnknown": rememberStateUnknown
            };
            log('Block rendering: markup rendering parameters: ', renderParams, '.');
            var markup = renderUserBlock($, renderParams);

            var placeholder = detectPlaceholder(options);

            if(hooks.afterRender) {
                var afterRenderArgs = {
                    "data": data,
                    "rememberStateUnknown": rememberStateUnknown,
                    "markup": markup,
                    "placeholder": placeholder
                };
                hooks.afterRender(afterRenderArgs);
                markup = afterRenderArgs.markup;
                placeholder = afterRenderArgs.placeholder;
            }

            placeholder.html(markup);
        }

        function render(data) {
            var renderData;
            var rememberStateUnknown;

            if (data && data.users) {
                rememberStateUnknown = false;
                renderData = data;
            } else if (data) {
                rememberStateUnknown = false;
                renderData = {};
            } else if (options.wmId) {
                rememberStateUnknown = true;
                renderData = {};
            }

            if(hooks.beforeRender) {
                var beforeRenderArgs = {
                    "data": renderData,
                    "rememberStateUnknown": rememberStateUnknown
                };
                hooks.beforeRender(beforeRenderArgs);
                renderData = beforeRenderArgs.data;
                rememberStateUnknown = beforeRenderArgs.rememberStateUnknown;
            }

            if (renderData) {
                doRender(renderData, rememberStateUnknown);
            } else {
                log('Block rendering: render data is missing, insufficient or invalid; data: ', data, ', options: ', options, '.');
            }
        }

        function handleData(data) {
            if(options.wmId || data && data.wmId && data.loggedOn) {
                SingleSignOn.sessionSetCalled(true);
            }

            render(data);
        }

        function testPreRender(options) {
            if(options.preRender === true) {
                log('Pre-rendering: pre-rendering is enabled.');
                return true;
            }

            if(options.preRender === false) {
                log('Pre-rendering: pre-rendering is disabled.');
                return false;
            }

            var placeholder = detectPlaceholder(options);
            var result = !placeholder.children ||
                         placeholder.children('.login_popup_cont').length === 0;
            log('Pre-rendering: auto-detected pre-rendering setting: ', result, '.');
            return result;
        }

        instance.handleData = handleData;
        instance.render = render;
        instance.detectPlaceholder = detectPlaceholder;
        instance.testPreRender = testPreRender;

        return instance;
    })();

    var handleData;
    if(options.handleData) {
        handleData = options.handleData;
        log('AJAX: custom callback function detected.');
    } else if(options.signOn) {
        if (!(uriService.userChange || uriService.rid)) {
            throw new Error('Required parameter options.uriService is missing or contains an invalid value.');
        }
        if(!uriService.returnUrl) {
            uriService.returnUrl = window.location;
        }

        log('AJAX: using single sign on callback.');
        handleData = SingleSignOn.handleData;
    } else {
        log('AJAX: using user block render callback.');
        handleData = UserBlockRenderer.handleData;

        if(UserBlockRenderer.testPreRender(options)) {
            try {
                UserBlockRenderer.render(undefined);
            } catch(e) {
                log('Pre-rendering: pre-rendering raised an exception: ', e, '.');
            }
        }
    }

    var allowGetUserData = isCorsFullSupported() || isSameDomain(location, uri);
    if(hooks.beforeGetUserData) {
        var beforeGetUserDataArgs = {
            "allowGetUserData": allowGetUserData,
            "uri": uri
        };
        hooks.beforeGetUserData(beforeGetUserDataArgs);
        allowGetUserData = beforeGetUserDataArgs.allowGetUserData;
        uri = beforeGetUserDataArgs.uri;
    }

    if(allowGetUserData) {
        var ajaxSettings = {
            url: uri,
            method: 'GET',
            data: {
                "type": "cors"
            },
            cache: true,
            dataType: "json",
            success: function(d) {
                log('AJAX: received Login response: ', d, '.');
                try {
                    if(hooks.afterGetUserData) {
                        var afterGetUserDataArgs = {
                            "allowGetUserData": true,
                            "data": d
                        };
                        hooks.afterGetUserData(afterGetUserDataArgs);
                        d = afterGetUserDataArgs.data;
                    }
                    handleData(d);
                } catch(e) {
                    log('AJAX: callback raised an exception: ', e, '.');
                    throw e;
                }
            },
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        log('AJAX: initiating AJAX request. AJAX parameters: ', ajaxSettings, '.');
        $.ajax(ajaxSettings);
    } else {
        log('AJAX: browser can does not fully support CORS.');
        var data;
        if(hooks.afterGetUserData) {
            var afterGetUserDataArgs = {
                "allowGetUserData": false,
                "data": data
            };
            hooks.afterGetUserData(afterGetUserDataArgs);
            data = afterGetUserDataArgs.data;
        }
        handleData(data);
    }
}

// ReSharper restore DeclarationHides
    /* globals loadUserBlock: false */
    /* globals console: false */

    var scripts = document.getElementsByTagName('script');
    var thisScriptTag = scripts[scripts.length - 1];

    function main() {
        var loggingEnabled = $('html').data().userBlockLog || false;
        var log;
        if(loggingEnabled && console.log) {
            log = function() {
                var args = [];
                for(var i in arguments) {
                    var a = arguments[i];
                    if(typeof a === 'string') {
                        args.push(a);
                    } else {
                        args.push(JSON.stringify(a));
                    }
                }
                var argsString = args.join("");
                console.log(argsString);
            };
        } else {
            log = function() {};
        }

        var placeholderGetters = [
            function () {
                log('Placeholder detection: checking <script>.');
                return thisScriptTag ? $(thisScriptTag) : null;
            },
            function () {
                log('Placeholder detection: checking <* data-role="header-user-block">.');
                return $('[data-role="header-user-block"]');
            },
            function () {
                log('Placeholder detection: checking <* id="header-user-block">.');
                return $('#header-user-block');
            },
            function () {
                log('Placeholder detection: checking <* class="header-user-block">.');
                return $('.header-user-block');
            },
            function () {
                log('Placeholder detection: checking <* class="header-user-buttons">.');
                return $('.header-user-buttons');
            }
        ];
        var placeholder = null;
        var options = null;
        for (var i in placeholderGetters) {
            if (placeholderGetters.hasOwnProperty(i)) {
                placeholder = placeholderGetters[i]();
                if (placeholder) {
                    options = placeholder.data();
                    log('Placeholder detection: element data: ', options, '.');

                    if (options && (options.wmid || options.signOn === true)) {
                        log('Placeholder detection: placeholder found!');
                        break;
                    } else {
                        log('Placeholder detection: placeholder missing data-wmid and data-sign-on.');
                        placeholder = null;
                        options = null;
                    }
                } else {
                    log('Placeholder detection: no matching elements found.');
                }
            }
        }

        if (placeholder && options) {
            if (placeholder.prop("tagName") === 'SCRIPT') {
                placeholder = $('<td class="header-user-block"></td>').insertAfter(placeholder);
                log('Placeholder detection: added user block element after <script> placeholder.');
            }

            options.wmId = options.wmid;

            var wmIdLen = 12;
            var wmId = '' + options.wmId;
            if (wmId.length < wmIdLen) {
                wmId = '000000000000'.substr(0, wmIdLen - wmId.length) + wmId;
            }
            options.wmId = wmId;

            if (!options.sr) {
                options.sr = {};
                if (options.srUserChange) {
                    options.sr.User_Change = options.srUserChange;
                }
                if (options.srUserSettings) {
                    options.sr.User_Settings = options.srUserSettings;
                }
                if (options.srUserSignoff) {
                    options.sr.User_SignOff = options.srUserSignoff;
                }
                if (options.srBack) {
                    options.sr.Back = options.srBack;
                }
            }

            if (!options.uriservice) {
                options.uriservice = {};
                if (options.uriserviceUserKeeper) {
                    options.uriservice.userKeeper = options.uriserviceUserKeeper;
                }
                if (options.uriserviceUserProfile) {
                    options.uriservice.userProfile = options.uriserviceUserProfile;
                }
                if (options.uriserviceLoginSettings) {
                    options.uriservice.loginSettings = options.uriserviceLoginSettings;
                }
                if (options.uriserviceUserSignoff) {
                    options.uriservice.userSignoff = options.uriserviceUserSignoff;
                }
                if (options.uriserviceUserChangeNew) {
                    options.uriservice.userChangeNew = options.uriserviceUserChangeNew;
                }
                if (options.uriserviceUserChange) {
                    options.uriservice.userChange = options.uriserviceUserChange;
                }
                if (options.uriserviceRid) {
                    options.uriservice.rid = options.uriserviceRid;
                }
                if(options.uriserviceReturnurl) {
                    options.uriservice.returnUrl = options.uriserviceReturnurl;
                }
                if(options.uriserviceLogin) {
                    options.uriservice.login = options.uriserviceLogin;
                }
                if(options.uriserviceLoginSso) {
                    options.uriservice.loginSso = options.uriserviceLoginSso;
                }
            }
            options.uriService = options.uriservice;

            options.placeholder = placeholder;

            if(loggingEnabled) {
                options.log = loggingEnabled;
            }

            var loadUserBlockImpl = window.loadUserBlock || loadUserBlock;
            try {
                loadUserBlockImpl(options);
            } catch(e) {
                log('Loading user block: Failed to load user block: ', e, '.');
                throw e;
            }
        } else {
            log('Placeholder detection: no valid placeholder lement found.');
        }
    }

    $('body').on('header-loaded',function(){
        $(main);
    });
}(window.jQuery));

(function( $ ){
  $('body').on('header-loaded',function(){
    var headerUser = $('.header-user');
    if(!headerUser.data('user-block-handlers-set')) {
      headerUser.data('user-block-handlers-set', true);

      headerUser.on('click', '.user-link-to-events', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.login_popup_cont').toggleClass('active');
        $('body').append('<div class="overlay_bg"></div>');
      });

      $(document).on('click', function(event) {
        if (!$(event.target).parents().addBack().is('.user-link-to-events')) {
          $('.user-link-to-events, .login_popup_cont').removeClass('active');
          $('.overlay_bg').hide();
        }
      });

      $('.login_popup_cont').on('click', function(event) {
        event.stopPropagation();
      });

      headerUser.on('click', '.login_close', function (e) {
        e.preventDefault();
        $('.overlay_bg').hide();
        $('.user-link-to-events, .login_popup_cont').removeClass('active');
        return false;
      });
    }
  });
})(window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./vendor/user.block.autoload.js
// module id = 634
// module chunks = 2